import * as DialogPrimitive from '@radix-ui/react-dialog';

const Modal = DialogPrimitive.Root;
const ModalTrigger = DialogPrimitive.Trigger;
const ModalClose = DialogPrimitive.Close;
const ModalTitle = DialogPrimitive.Title;
const ModalDescription = DialogPrimitive.Description;

export { Modal, ModalTrigger, ModalClose, ModalTitle, ModalDescription };
export default Modal;
